import React from 'react';
import AccountForm from './AccountForm';

export default {
  title: 'Pages/Admin/AccountForm',
  component: AccountForm,
};

const Template = (args) => <AccountForm {...args} />;

export const Edit = Template.bind({});
Edit.args = {
  initialData: {
    firstName: 'CTD',
    lastName: 'Admin',
    email: 'admin@gmail.com',
  },
};
